import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ArticleEditComponent} from './articles/article-edit/article-edit.component';

@Injectable()
export class CanDeactivateForm<T extends ArticleEditComponent> implements CanDeactivate<T> {

    constructor() {
    }

    canDeactivate(
        component: T,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (component.form()) {
            return component.openChangesBackActionCheck();
        }
        return true;
    }
}
